/**
 * The "face" of an open-board challenge that nobody has taken yet.
 *
 * Such a challenge has exactly one participant by design, so the card has no opponent to draw:
 * it used to fall through to a bare initials circle. It gets the default group cover and the
 * "Anyone" label instead. Once a taker accepts, `takenAt` is set and the card renders as a
 * normal duel against the real opponent. specs/open-challenges AC-14/AC-15.
 */

export interface OpenChallengeFaceInput {
  isOpen?: boolean;
  takenAt?: string | Date | null;
}

export function isUntakenOpenChallenge(challenge: OpenChallengeFaceInput | null | undefined): boolean {
  if (challenge == null) return false;
  return challenge.isOpen === true && challenge.takenAt == null;
}
